import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";

const sortOptions = [
  { name: "Recommended", value: "asc" },
  { name: "Price: Low to High", value: "asc" },
  { name: "Price: High to Low", value: "desc" },
  { name: "Newest", value: "newest" },
  { name: "Oldest", value: "oldest" },
];

const SortDropdown = ({ selectedSort, onChange }) => {
  const [open, setOpen] = useState(false);
  const selectedLabel =
    sortOptions.find((option) => option.value === selectedSort && option.name !== "Recommended")
      ?.name || "Recommended";

  useEffect(() => {
    function handleClickOutside(event) {
      if (open && !event.target.closest(".sort-dropdown")) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="relative inline-block text-left sort-dropdown">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="inline-flex items-center gap-2 border border-stone-300 bg-white px-3 py-2 font-sans text-[13px] leading-5 font-light text-[#333333]"
      >
        Sort By :{selectedLabel}
        <ChevronDownIcon className="h-4 w-4 text-[#333333]" />
      </button>

      {open && (
        <div className="absolute right-0 z-20 mt-1 w-48 origin-top-right bg-white border border-stone-200 shadow-md">
          <div className="py-1">
            {sortOptions
              .filter((option, index, all) => all.findIndex((item) => item.name === option.name) === index)
              .map((option) => (
                <button
                  key={option.name}
                  type="button"
                  onClick={() => {
                    onChange(option.value);
                    setOpen(false);
                  }}
                  className={`block w-full px-4 py-2 text-left font-sans text-[13px] ${
                    selectedLabel === option.name
                      ? "bg-stone-800 text-white"
                      : "text-[#333333] hover:bg-stone-50"
                  }`}
                >
                  {option.name}
                </button>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
